/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { WidgetCaptionContainer, CaptionIcon, CaptionInfoText } from './commonStyles';

export const WidgetCaptionLoadingUI = () => {
    return (
        <WidgetCaptionContainer>
            <CaptionIcon>
                <AnimatedLoadingPlaceholder height='24px' radius={70} /> 
            </CaptionIcon>
            <CaptionInfoText>
                <AnimatedLoadingPlaceholder height='70%' />
            </CaptionInfoText>
        </WidgetCaptionContainer>
    );
};
